var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRotateLeft = function SvgRotateLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.5C4 1.7 3.3 1 2.5 1S1 1.7 1 2.5V10h6.5C8.3 10 9 9.3 9 8.5S8.3 7 7.5 7H5.3c.9-1.8 2.8-3 5-3 3.1 0 5.6 2.5 5.6 5.5S13.4 15 10.3 15c-1.7 0-3.1-.7-4.2-1.8-.5-.7-1.5-.7-2.1-.2-.6.6-.7 1.5-.1 2.1 1.6 1.7 3.9 2.8 6.5 2.8 4.8 0 8.7-3.8 8.7-8.5-.1-4.6-4-8.4-8.8-8.4C7.8 1 5.6 2 4 3.7V2.5z"
  })));
};
export default SvgRotateLeft;